import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Main.css';

const MainPage: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['main'];

  return (
    <section className="main-section">
      <img src="/img/logo.png" alt="Logo potoexpress.com" width={340} className="logo-img m-5" />
      <Container className="vh-100 d-flex flex-column justify-content-center">
        <Row className="w-100 justify-content-center">
          <Col md={6} className="left-side d-flex flex-column justify-content-center align-items-center">
            <h1 dangerouslySetInnerHTML={{ __html: t.title }} className="text-center m-5"/>
            <Button href="#about" variant="btn btn-red mb-4 p-4">
              {translations[language]['main']['button']}
            </Button>
          </Col>
          <Col md={6} className="right-side d-flex justify-content-center align-items-center">
            <img src="/img/MainImage.png" alt="Background" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MainPage;
